// The rolling headline's rhythm, from the prototype's hero-type.js

/**
 * The hand-over's length. The incoming word's 120ms delay plus its 770ms
 * travel in the stylesheet add up to this, so the swap commits as the word
 * lands.
 */
export const ROLL_MS = 890;

/** A phrase holds this long before it hands over... */
const HOLD_MS = 2133;
/** ...plus this much per character... */
const PER_CHAR_MS = 63;
/** ...plus up to this much at random, so no two waits are the same. */
const HOLD_VARY_MS = 333;

/** How long a phrase stays before the next one rolls in */
export const holdLength = (
    phrase: string,
    random: () => number = Math.random,
) => HOLD_MS + phrase.length * PER_CHAR_MS + random() * HOLD_VARY_MS;

/** Straight down the list and round again, in the order it's written. */
export const nextIndex = (index: number, count: number) => (index + 1) % count;

/**
 * The screen-reader line: every ending, read as one sentence ("a, b, or c.").
 * Each ending's own closing punctuation is dropped so the list ends on one
 * period. The rolling line itself is hidden from assistive tech.
 */
export const endingsSentence = (endings: readonly string[]) =>
    `${new Intl.ListFormat("en", { type: "disjunction" }).format(
        endings.map((ending) => ending.trim().replace(/[.!?]+$/, "")),
    )}.`;
